import { withStyles } from '@material-ui/core';
import styles from './InventoryDrawer.styles';
import InventoryDrawer from './InventoryDrawer';

export default withStyles(styles)(InventoryDrawer);
